
export const personal_info_steps_config =
{
    
    "stepGroupTitle": "stepTitle.personalInfo",
    "steps":  {
      "end-flow" : {
        "step_position": 0,
        "step_ID":"endFlow",
        "step_URL":"end-flow",
        "step_form" : []
      },
      "identity" : {
        "step_position": 1,
        "step_ID":"identity",
        "step_URL":"identity",
        "step_form" : [
          {
            type: "text",
            id: "first_name",
            label: "personal_infos.personal_info_name.first_name"
          },
          {
            type: "text",
            id: "last_name",
            label: "personal_infos.personal_info_name.last_name"
          }]
      },
      "email" : {
        "step_position": 2,
        "step_ID":"email",
        "step_URL":"email",
        "step_form" : [
            {
              type: "email",
              id: "email",
              label: "personal_infos.Personal_info_email_address.email",
              max: 55
            },
            {
              type: "checkbox",
              id: "optin_email",
              label: "personal_infos.Personal_info_email_address.opt_in"
            }]
      },
      "phone" :{
        "step_position": 3,
        "step_ID":"phone",
        "step_URL":"phone",
        "step_form" : [
          {
            type: "phone",
            id: "internal_mobile_phone_number",
            max: 12
          },
          {
            type: "checkbox",
            id: "optin_mobile",
            label: "personal_infos.personal_info_phone_number.optin"
          }]
      },
      "belgian-residence" : {
        "step_position": 4,
        "step_ID":"belgium_resident",
        "step_URL":"belgian-residence"
      },
      "legal-address" : {
        "step_position": 5,
        "step_ID":"legalAddress",
        "step_URL":"legal-address",
        "step_form": [
          {
            type: "text",
            id: "street",
            label: "personal_infos.Personal_info_address.street_name",
            max:40
          },
          {
            type: "text",
            id: "house_number",
            label: "personal_infos.Personal_info_address.street_number",
            max:6

          },
          {
            type: "text",
            id: "box",
            label: "personal_infos.Personal_info_address.box",
            max: 6,
          },
          {
            type: "postCode",
            id: "__postal-input",
            // label: "Code postal / Ville / Commune"
            label: "personal_infos.Personal_info_address.postal_code"
          },
        ]
      },
      "date-of-birth" : {
        "step_position": 6,
        "step_ID":"dateOfBirth",
        "step_URL":"date-of-birth",
        "step_form": [
          {
            type: "date",
            id: "birthday",
            label: "personal_infos.Personal_info_birth_date.label"
          },
        ]

      },
      "place-of-birth" : {
        "step_position": 7,
        "step_ID":"placeOfBirth",
        "step_URL":"place-of-birth",
        "step_form": [
          {
            type: "country",
            id: "birth_country",
            label: "personal_infos.Personal_info_birth_place.country_label"
          }
        ]
      },
      "nationality" : {
        "step_position": 8,
        "step_ID":"nationality",
        "step_URL":"nationality"
      },
      // "national-number" : {
      //   "step_position": 9,
      //   "step_ID":"nationalNumber",
      //   "step_URL":"national-number",
      //   "step_form": [
      //     {
      //       type: "txt",
      //       id: "national_reg_num",
      //       label: "personal_infos.Personal_info_national_registration_number.label"
      //     },
      //   ]
      // },
      "marital-status" : {
        "step_position": 9,
        "step_ID":"civil_state",
        "step_URL":"marital-status"
      },
      "summary" :{
        "step_position": 10,
        "step_ID":"summary",
        "step_URL":"summary"
      },
           "closer" :{
        "step_position": 11,
        "step_ID":"summary",
        "step_URL":"summary"
      }
    }

  }

export const legal_info_steps_config =
  {
    "stepGroupTitle": "Questions légalement obligatoires",
    "steps":  {

      "usage" : {
        "step_position": 13,
        "step_ID":"hb_usage",
        "step_URL":"usage"
      },
      "occupation" : {
        "step_position": 14,
        "step_ID":"occupation_activity",
        "step_URL":"occupation"
      },
      "income" : {
        "step_position": 15,
        "step_ID":"income",
        "step_URL":"income"
      },
      "income-source" : {
        "step_position": 16,
        "step_ID":"income_source",
        "step_URL":"income-source"
      }, 
        "income-source-other" : {
        "step_position": 16,
        "step_ID":"income_source_other",
        "step_URL":"income-source-other"
      },
      "fiscal-residence" : {
        "step_position": 17,
        "step_ID":"fiscal_residence",
        "step_URL":"fiscal-residence"
      },
      "us-address" : {
        "step_position": 18,
        "step_ID":"has_us_address",
        "step_URL":"us-address"
      },
      "us-citizen" : {
        "step_position": 19,
        "step_ID":"is_us_citizen",
        "step_URL":"us-citizen"
      },
      "political" : {
        "step_position": 20,
        "step_ID":"PEP",
        "step_URL":"political"
      },
      "insider" : {
        "step_position": 21,
        "step_ID":"ubo",
        "step_URL":"insider"
      },
      "join-reason" : {
        "step_position": 22,
        "step_ID":"join_reason",
        "step_URL":"join-reason"
      },
         "join-reason-other" : {
        "step_position": 22,
        "step_ID":"join_reason_other",
        "step_URL":"join-reason-other"
      },
      "summary" : {
        "step_position": 23,
        "step_ID":"summary",
        "step_URL":"summary"
      },

      "id-card" : {
        "step_position": 24,
        "step_ID":"idcard",
        "step_URL":"id-card"
      },
      
      "end-flow" : {
        "step_position": 25,
        "step_ID":"endFlow",
        "step_URL":"end-flow",
        "step_form" : []
      },
    }

}

export const pro_info_steps_config = {
  "stepGroupTitle": "Professionnal information",
  "steps": {
      "has-enterprise" : {
        "step_position": 26,
        "step_ID":"has_enterprise",
        "step_URL":"has-enterprise"
    },
    "enterprise-number" : {
        "step_position": 27,
        "step_ID":"enterprise_number",
          "step_URL": "enterprise-number",
        "step_form": [
          {
            type: "txt",
            id: "enterprise_number",
            label: "pro_infos.pro_info_what_is_your_business_number.label"
          },
        ]
    },
    "enterprise-name" : {
        "step_position": 27,
        "step_ID":"enterprise_name",
        "step_URL":"enterprise-name"
    },
        "has-enterprise-name" : {
        "step_position": 27,
        "step_ID":"enterprise_name",
        "step_URL":"has-enterprise-name"
    },
    "establishment-date" : {
        "step_position": 28,
        "step_ID":"establishment_date",
        "step_URL":"establishment-date"
    },
        "has-establishment-date" : {
        "step_position": 28,
        "step_ID":"establishment_date",
        "step_URL":"has-establishment-date"
    },
    "enterprise-activity-code" : {
        "step_position": 29,
        "step_ID":"enterprise_activity_code",
        "step_URL":"enterprise-activity-code"
    },
    "enterprise-activity-country" : {
        "step_position": 30,
        "step_ID":"enterprise_activity_country",
        "step_URL":"enterprise-activity-country"
    },
   "pro-info-review" : {
        "step_position": 31,
        "step_ID":"pro_info_review",
        "step_URL":"pro-info-review"
    },
    "pre-confirmation" : {
      "step_position": 32,
      "step_ID":"pre_confirmation",
      "step_URL":"pre-confirmation",
      "step_form" : []
  },
        "end-flow" : {
      "step_position": 33,
      "step_ID":"endFlow",
      "step_URL":"end-flow",
      "step_form" : []
    },
  }
}

export const total_steps = () => Object.keys(personal_info_steps_config).length + Object.keys(legal_info_steps_config.steps).length

